import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { ImmomioIconName } from '@resident-nx/shared';
import { TranslateModule } from '@ngx-translate/core';
import { ElevationDirective, IconWebComponent } from '@resident-nx/web/ui';
import { ImmomioButtonComponent } from '@immomio/ui/button';

@Component({
  standalone: true,
  selector: 'rs-web-archive-tickets-card',
  imports: [IconWebComponent, ImmomioButtonComponent, ElevationDirective, TranslateModule],
  templateUrl: './archive-tickets-card.component.html',
  styleUrl: './archive-tickets-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArchiveTicketsCardWebComponent {
  readonly titleText = input.required<string>();
  readonly buttonText = input.required<string>();
  readonly icon = input.required<ImmomioIconName>();
  readonly showNotification = input(false);
  // Emits only on the first expand, so the archive is loaded once.
  readonly expanded = output();
  public isCollapsed = signal(true);
  protected readonly immomioIconName = ImmomioIconName;
  #hasExpanded = false;

  public toggleCollapsed() {
    this.isCollapsed.update(collapsed => !collapsed);
    if (!this.#hasExpanded) {
      this.#hasExpanded = true;
      this.expanded.emit();
    }
  }
}
